module.exports = "img/flags/GM.5181e38.png";